import { render } from "./OptimizationDetail.vue?vue&type=template&id=56b433ac&scoped=true"
import script from "./OptimizationDetail.vue?vue&type=script&lang=js"
export * from "./OptimizationDetail.vue?vue&type=script&lang=js"

import "./OptimizationDetail.vue?vue&type=style&index=0&id=56b433ac&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./OptimizationDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b433ac"]])

export default __exports__